// extracted by mini-css-extract-plugin
export default {"statsTableEmptyCont":"dCD3Qp5PwmtJAFKKEL5Q","statsTableEmptyImage":"WDMS9J4ok0EKLN2CAN3t","statsTableEmptyHeader":"gXNog3XJgKoxZHzaHjuH","statsTableEmptyDesc":"LkuJl2mAwk_QuX3hUESN"};